// John Eldhose 20200731
import React, { Component } from 'react';
import { Checkbox, Typography } from '@material-ui/core';
import { Star } from '@material-ui/icons';
import { postAcademy } from './lib';
import Loading from '../../lib/Loading';

class RatingEdit extends Component {

  state = {
    loading: true,
    rating: 0
  }
  componentWillMount() {
    postAcademy('data', { property: '_rating', did: this.props.parms.id }, (res) => {
      if(
        typeof res.data[0] !== 'undefined' &&
        typeof res.data[0].data !== 'undefined'
      )
        this.setState({ loading: false, rating: res.data[0].data });
      else
        this.setState({ loading: false });
    });
  }
  handleRating = (rating) => {
    this.setState({ loading: true });
    postAcademy('data', { property: '_rating', did: this.props.parms.id, save: rating }, (res) => {
      if(
        typeof res.data[0] !== 'undefined' &&
        typeof res.data[0].data !== 'undefined'
      )
        this.setState({ loading: false, rating: res.data[0].data });
      else
        this.setState({ loading: false });
    });
  }
  checkbox = (rating) => {
    return (
      <Checkbox
        icon={<Star />}
        checkedIcon={<Star style={{ color: 'gold' }} />}
        checked={this.state.rating >= rating}
        onClick={() => this.handleRating(rating)}
      />
    );
  }
  content = () => {
    return (
      <div style={{ padding: '30px 0' }}>
        <Typography>Rate this course</Typography>
        {this.checkbox(1)}
        {this.checkbox(2)}
        {this.checkbox(3)}
        {this.checkbox(4)}
        {this.checkbox(5)}<p />
      </div>
    );
  }

  render() {
    if(this.state.loading)
      return <Loading />;
    else
      return this.content();
  }
}

export default RatingEdit;



// WEBPACK FOOTER //
// ./src/components/home/academy/RatingEdit.js